import {HttpClient, HttpContext} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {
  CreateReportRequest,
  CreateReportResponse,
  ReportDownloadResponse,
} from '@gatewee/types/report';
import {TaskScope} from '@gatewee/types/task';
import {Observable} from 'rxjs';
import {SKIP_SPINNER} from './tokens/spinner.token';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  private readonly http = inject(HttpClient);

  create(
    scope: TaskScope,
    body: CreateReportRequest,
    skipSpinner = false,
  ): Observable<CreateReportResponse> {
    return this.http.post<CreateReportResponse>(`/reports/${scope}`, body, {
      context: new HttpContext().set(SKIP_SPINNER, skipSpinner),
    });
  }

  download(
    scope: TaskScope,
    reportId: number,
    skipSpinner = false,
  ): Observable<ReportDownloadResponse> {
    return this.http.get<ReportDownloadResponse>(
      `/reports/${scope}/${reportId}/download`,
      {
        context: new HttpContext().set(SKIP_SPINNER, skipSpinner),
      },
    );
  }
}
